import basicRest from '../common/CommonRestFunctions'

const baseLandBatchUrl = '/land-batch'

export default {
  getLandBatches () {
    return basicRest.executeBasicAxiosGet(baseLandBatchUrl + '/list')
  },
  saveLandBatch (landBatch) {
    return basicRest.executeBasicAxiosPost(baseLandBatchUrl + '/save', landBatch)
  },
  removeLandBatch (id) {
    return basicRest.executeBasicAxiosRemove(baseLandBatchUrl + '/remove/' + id)
  }
}
